import { ProcessesResponse } from 'types';

export const fields = ['agreementProcessId', 'processKennitala', 'initiatorsKennitala'];

export const defaultParams = {
	agreementProcessId: '',
	initiatorsKennitala: '',
	processKennitala: '',
	resultLimit: 9_000,
	refresh: 0
};

export type AdminTableColumn = keyof ProcessesResponse;

export const columns: AdminTableColumn[] = [
	'agreementProcessId',
	'kennitala',
	'kennitalaInitiator',
	'emailInitiator',
	'fullNameInitiator',
	'phoneInitiator',
	'flowType',
	'processStatus',
	'created',
	'modified'
];
